import {AfterViewInit, Component, Inject, OnInit, ViewChild} from '@angular/core';
import {AcDialog, DIALOG_CONFIG} from 'ac-infra';
import {NgForm} from '@angular/forms';
import * as _ from 'lodash';

@AcDialog({
  width: 500
})
@Component({
  selector: 'security-policies-dialog',
  templateUrl: './security-policies-dialog.component.html',
  styleUrls: ['./security-policies-dialog.component.scss']
})
export class SecurityPoliciesDialogComponent implements OnInit, AfterViewInit {

  @ViewChild('securityPoliciesForm') mapForm: NgForm;

  isEdit: boolean;
  data;
  baseRoles;
  permissionRoles;
  isDefault;
  dialogConf;
  baseRoleSelection;
  permissionRolesSelection = [];

  constructor(@Inject(DIALOG_CONFIG) private dialogConfig) {
    const roles = this.dialogConfig.dialogData.roles;

    this.data = this.dialogConfig.dialogData.selectedItem;
    this.isDefault = this.dialogConfig.dialogData.selectedItem.default;
    this.isEdit = this.dialogConfig.dialogData.isEditMode;
    this.dialogConf = dialogConfig;

    this.baseRoles = roles.filter(role => role.baseRole);
    this.permissionRoles = roles.filter(role => !role.baseRole);

    if (this.isEdit) {
      this.data.roles.forEach(role => {
        if ((this.baseRoles.findIndex(baseRole => baseRole.name === role) > -1) &&
          _.isNil(this.baseRoleSelection)) {
          this.baseRoleSelection = role;
        } else {
          this.permissionRolesSelection.push(role);
        }
      });
    } else {
      this.baseRoleSelection = this.baseRoles[0].name;
      this.data.roles.push(this.baseRoles[0].name);
    }
  }

  ngOnInit(): void {
  }

  ngAfterViewInit(): void {
    this.mapForm.form.statusChanges.subscribe(() => {
      this.dialogConf.submitButtonDisabled = !this.mapForm.form.valid;
    });
  }

  onRuleChanged(role: any): void {
    if (role.baseRole && role.name !== 'MONITOR') {
      this.data.roles = ['MONITOR', role.name];
      return;
    }

    const ruleIndex = this.permissionRolesSelection.indexOf(role.name);

    if (ruleIndex > -1) {
      this.permissionRolesSelection.splice(ruleIndex, 1);
    } else {
      this.permissionRolesSelection.push(role.name);
    }

    this.data.roles = ['MONITOR', ...this.permissionRolesSelection];
  }
}
